define(function (require) {

    window.lpTag = window.lpTag || {};

    var App = window.App || {};

    var lpUtils = require('utils/lpUtils');
    var LPQueue = require('web-agent-utils/LPQueue');
    var PollingManager = require('web-agent-utils/PollingManager');
    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');
    var lpBaseInfoController = require('web-agent-assets-js/lpBaseInfoController');
    var lpVisitMonitoringController = require('web-agent-assets-js/lpVisitMonitoringController');
    var lpAgentSessionVisitController = require('web-agent-assets-js/lpAgentSessionVisitController');
    var lpConsumerInfoController = require('web-agent-assets-js/lpConsumerInfoController');
    var lpGoalsController = require('web-agent-assets-js/lpGoalsController');
    var lpEngagementsController = require('web-agent-assets-js/lpEngagementsController');
    var lpCampaignsController = require('web-agent-assets-js/lpCampaignsController');
    var lpVisitorBehaviorController = require('web-agent-assets-js/lpVisitorBehaviorController');
    var lpLobsController = require('web-agent-assets-js/lpLobsController');
    var lpVisitorProfileController = require('web-agent-assets-js/lpVisitorProfileController');
    var lpWindowController = require('web-agent-assets-js/lpWindowController');
    var lpBotMetadataInfoController = require('web-agent-assets-js/lpBotMetadataInfoController');

    lpTag.lpVisitorInfoController = function (model) {
        this.applicationType = "lpVisitorInfoController";
        var pollingEnabled = true;
        var pollingVisitors = {};
        var inactiveVisitors = {};
        var pollingQueue = new LPQueue({key: 'visitorId'});
        var pollingTimerId;
        var POLLING_TIMEOUT = lpTag.WebAgent.logicController.getPollingRefreshRateFromSiteSettings('le.agent.visitInfo.refreshRate', 20000) / 1000;
        var logger = WebAgentLogger.getLogger(this.applicationType);
        var visitorCallbacks = {};
        var chatCallbacks = {};
        var chatsResumedCallbackFunction = null;
        var visitorPollingManager;
        var visitMonitoringController,
        agentSessionVisitController,
        consumerInfoController,
        goalsController,
        campaignsController,
        visitorProfileController,
        visitorBehaviorController,
        lobsController,
        engagementsController,
        sdeDataHandler,
        windowController,
        botMetadataController;
        var chatsResumed;

        var dataStates = {
            fetching: 'fetching',
            success: 'success',
            partial: 'partial',
            error: 'error'
        };

        this.startPolling = function () {
            pollingEnabled = true;
            startPolling(this);
        };

        this.stopPolling = function () {
            pollingEnabled = false;
            stopPolling();
        };

        this.startPollingVisitorInfo = function (visitorId, appServerVisitorId, sessionId, convId) {
            logger.info("visitorId:" + visitorId, "startPollingVisitorInfo");
            if (visitorId) {
                var participantPath = lpTag.WebAgent.logicController.getParticipantPath(visitorId);
                var modelData = model.get(participantPath);
                if (!modelData) {
                    // can be any context
                    visitorPollingManager.setActiveItem({
                        visitorId: visitorId,
                        sessionId: sessionId,
                        appServerVisitorId: appServerVisitorId,
                        convId: convId,
                        context: this
                    });
                } else {
                    // can be any context
                    startPollingVisitorInfo({
                        visitorId: visitorId,
                        sessionId: sessionId,
                        appServerVisitorId: appServerVisitorId,
                        convId: convId,
                        context: this,
                        needToBindChatState: true
                    });
                }
            }
        };

        this.stopPollingVisitorInfo = function (visitorId, forceStop) {
            logger.info("visitorId:" + visitorId, "stopPollingVisitorInfo");
            if (visitorId) {
                var participantPath = lpTag.WebAgent.logicController.getParticipantPath(visitorId);
                var modelData = model.get(participantPath);
                if (!modelData || forceStop) {
                    // We only want this to happen for visitors that aren't in my engagements
                    // Visitors that are in my engagements will be removed via dispose visitors
                    visitorPollingManager.setInactiveItem({visitorId: visitorId});
                }
            }
        };

        this.handleNewParticipant = function (data) {
            if (data && data.newValue) {
                var visitors = Object.keys(data.newValue);
                for (var visitor in visitors) {
                    var visitorId = visitors[visitor];
                    var visitorData = data.newValue[visitorId];
                    if (visitorData && visitorData.participantInfo) {
                        // can be any context
                        var idObj = {visitorId: visitorId, context: this};
                        if (visitorData.participantInfo.shark) {
                            idObj.appServerVisitorId = visitorData.participantInfo.appServerVisitorId;
                            idObj.sessionId = visitorData.participantInfo.sessionId;
                        } else {
                            idObj.appServerVisitorId = visitorId;
                        }
                        idObj.isAsyncMessaging = lpTag.WebAgent.logicController.isVisitorAsyncMessaging(visitorId);
                        if (!visitorCallbacks[visitorId]) {
                            visitorCallbacks[visitorId] = {};
                        }
                        visitorCallbacks[visitorId].newChat = lpUtils.callbackContextWrapper(handleNewChat, idObj);
                        visitorCallbacks[visitorId].visitorDisposed = lpUtils.callbackContextWrapper(handleVisitorDisposed, idObj);
                        var participantPath = lpTag.WebAgent.logicController.getParticipantPath(visitorId);
                        model.bind(participantPath + ".chats", visitorCallbacks[visitorId].newChat);
                        model.bind(participantPath, visitorCallbacks[visitorId].visitorDisposed);
                    }
                }
            }
        };

        /**
         * Handles a new chat that's been added for a visitor. We only bind to the state (and start polling) if we've
         * finished resuming. This is to avoid polling multiple chats for the same visitor, if there was a split-session.
         * @param data - The chat ID (newValue) and the context.
         */
        function handleNewChat(data) {
            if (!data.newValue) {
                return;
            }
            var chatId;
            var chatIds = Object.keys(data.newValue);
            for (var chat in chatIds) {
                chatId = chatIds[chat];
                data.context.chatId = chatId;
                data.context.newChat = true;
                deleteConflictingParamsFromModel(data.context && data.context.visitorId);
                if (finishedResuming()) {
                    bindToChatState(data.context);
                } else {
                    data.context.needToBindChatState = true;
                    addToList(data.context, pollingVisitors);
                }
            }
        }

        /**
         * Deletes certain parameters from the model that might conflict in case of a split session.
         * @param visitorId The ID of the visitor.
         */
        function deleteConflictingParamsFromModel(visitorId) {
            if (visitorId) {
                model.removeKey('participants.info.' + visitorId + '.state');
                model.removeKey('participants.info.' + visitorId + '.data.skill');
                model.removeKey(lpTag.WebAgent.logicController.getParticipantPath(visitorId) + ".participantInfo.skill");
                model.removeKey('participants.info.' + visitorId + '.data.window');
                model.removeKey('participants.info.' + visitorId + '.data.rtSessionId');
                model.removeKey('participants.info.' + visitorId + '.data.chatRequestTime');
                model.removeKey('participants.info.' + visitorId + '.data.chatAcceptTime');
                model.removeKey('participants.info.' + visitorId + '.data.participant');
            }
        }

        /**
         * Indicates if we've finished resuming.
         * @returns true if we've finished resuming. False if we haven't.
         */
        function finishedResuming() {
            return chatsResumed;
        }

        function bindToChatState(context) {
            if (context && context.chatId) {
                if (!chatCallbacks[context.chatId]) {
                    chatCallbacks[context.chatId] = {};
                }
                if (!chatCallbacks[context.chatId].chatStateChanged) {
                    chatCallbacks[context.chatId].chatStateChanged = lpUtils.callbackContextWrapper(handleChatStateChanged, context);
                    model.bind("chats." + context.chatId + ".chatInfo.state", chatCallbacks[context.chatId].chatStateChanged);
                }
            }
        }

        /**
         * Called when the chat state changes (at least once per chat).
         * If a chat is ended or transferred - we want to poll it once, then stop polling.
         * @param data - The new state of the chat (in newValue), and the context.
         */
        function handleChatStateChanged(data) {
            var visitorId = data.context.visitorId;
            var chatId = data.context.chatId;
            var state = data.newValue;
            data.context.needToBindChatState = false;
            enrichList({visitorId: visitorId, chatId: chatId, chatState: state}, pollingVisitors);
            startPollingVisitorInfo(data.context);
            if (data.context.newChat) {
                data.context.newChat = false;
            }
            if (isChatEnded(state)) {
                removeChatFromList(chatId);
                bindToUIEvents(visitorId);
            }
        }

        function removeChatFromList(chatId) {
            if (chatCallbacks[chatId] && chatCallbacks[chatId].chatStateChanged) {
                model.unbind("chats." + chatId + ".chatInfo.state", chatCallbacks[chatId].chatStateChanged);
                chatCallbacks[chatId].chatStateChanged = null;
                delete chatCallbacks[chatId];
            }
        }

        initializeApi(this);

    /**
     * Initializes everthing that's needed for the controller.
     * @param context - the current instance of the controller.
     */
    function initializeApi (context) {
        visitorPollingManager = new PollingManager({
            key: 'visitorId',
            startCallback: startPollingVisitorInfo,
            pauseCallback: stopPollingVisitorInfo,
            resumeCallback: startPollingVisitorInfo,
            pollingContext: context,
            removeDataCallback: removeVisitorInfoFromModel,
            dataContext: context
        });
        goalsController = new lpGoalsController(model);
        windowController = new lpWindowController(model);
        engagementsController = new lpEngagementsController(model, {
            getWindow : windowController.getWindow,
            windowContext: windowController
        });
        lobsController = new lpLobsController(model);
        campaignsController = new lpCampaignsController(model, {
            getLob: lobsController.getLob,
            lobContext: lobsController
        });
        visitorProfileController = new lpVisitorProfileController(model);
        visitorBehaviorController = new lpVisitorBehaviorController(model);
        agentSessionVisitController = new lpAgentSessionVisitController(model);
        consumerInfoController = new lpConsumerInfoController(model);
        botMetadataController = new lpBotMetadataInfoController(model);visitMonitoringController = new lpVisitMonitoringController(model, {
            getVisitorProfile: visitorProfileController.getVisitorProfile,
            visitorProfileContext: visitorProfileController,
            getVisitorBehavior: visitorBehaviorController.getVisitorBehavior,
            visitorBehaviorContext: visitorBehaviorController,
            getLob: lobsController.getLob,
            lobContext: lobsController,
            getGoal: goalsController.getGoal,
            getEngagement:engagementsController.getEngagement,
            engagementContext:engagementsController,
            getWindow : windowController.getWindow,
            windowContext: windowController,
            goalContext: goalsController,
            getCampaign: campaignsController.getCampaign,
            campaignContext: campaignsController,
            sdeHandler: sdeDataHandler
        });
        chatsResumedCallbackFunction = lpUtils.callbackContextWrapper(chatsResumedChanged, context);
        chatsResumed = false;
        model.bind(lpTag.lpVisitorInfoController.prototype.CURRENT_POLLING_MODEL_LOCATION, currentPollingChanged, context);
        model.bind('agent.chatsResumedCount', chatsResumedCallbackFunction);
        model.bind("participants.myEngagements", context.handleNewParticipant, context);
    }

        /**
         * Called when the number of resumed chats is updated (once). We use this simply to determine that we've finished
         * resuming.
         * @param data - contains the new value of the number of resumed chats. If it exists - we're done resuming.
         */
        function chatsResumedChanged(data) {
            if (data) {
                var context = data.context;
                if (typeof data.newValue !== 'undefined') {
                    chatsResumed = true;
                }
                if (context) {
                    if (isPollingActive()) {
                        pollVisitors();
                    }
                    startPolling(context);
                    model.unbind('agent.chatsResumed', chatsResumedCallbackFunction);
                }
            }
        }

        function isPollingActive() {
            return !!pollingTimerId;
        }

        function hasVisitorsToPoll() {
            return !!lpUtils.getFirstProperty(pollingVisitors);
        }

        function startPolling(context) {
            logger.info("", "startPolling", context);
            if (!isPollingActive() && hasVisitorsToPoll()) {
                if (window.App && window.App.timerManager && window.App.timerManager.registerTimer) {
                    pollingTimerId = window.App.timerManager.registerTimer({context: context, callback: pollVisitors, interval: POLLING_TIMEOUT}); //run until stopped
                }
                pollVisitors();
            }
        }

        function stopPolling() {
            logger.info("", "stopPolling");
            if (isPollingActive()) {
                window.App.timerManager.unregisterTimer({uniqueId: pollingTimerId});
                pollingTimerId = null;
            }
        }


        function pollVisitors() {
            if (pollingEnabled) {
                for (var visitorId in pollingVisitors) {
                    if (pollingVisitors.hasOwnProperty(visitorId)) {
                        getVisitorInfoOrBindToChatState(pollingVisitors[visitorId]);
                    }
                }
            }
        }

        function isChatEnded(state) {
            return state === 'ended' || state === 'transferred';
        }

        /**
         * Adds the data for a single visitor to the given list
         * @param data {*} The data for the visitor (and must contain the visitor ID)
         * @param list {*} Optional. The list to add to. If none is provided, the polling visitors are used.
         */
        function addToList(data, list) {
            var listToUse = list || pollingVisitors;
            if (data && data.visitorId && listToUse) {
                if (!listToUse[data.visitorId]) {
                    listToUse[data.visitorId] = {
                        visitorId: data.visitorId
                    };
                    if (inactiveVisitors[data.visitorId]) {
                        enrichList(inactiveVisitors[data.visitorId], listToUse);
                    }
                }
                enrichList(data, listToUse);
            }
        }

        /**
         * Gets the data for a single visitor from the active polling list, according to the visitor ID. If there's no
         * visitor ID, or no data for the visitor - the original data is returned.
         * @param data - The original request data, containing the visitor ID.
         * @returns Object containing the polling data.
         */
        function getFromActiveList(data) {
            if (data && data.visitorId && pollingVisitors[data.visitorId]) {
                return pollingVisitors[data.visitorId];
            } else {
                return data;
            }
        }

        /**
         * Enriches the data for a visitor in the list. Picks properties from the data to use.
         * @param data {*} contains data for the list.
         * @param list {*} Optional. The list to enrich. If none is provided, the polling visitors are used.
         * Visitor ID, context, app server visitor ID, session ID (shark), chat ID, new chat (boolean),
         * need to bind chat state (boolean)
         */
        function enrichList(data, list) {
            var listToUse = list || pollingVisitors;
            if (data && data.visitorId && listToUse && listToUse[data.visitorId]) {
                if (data.context) {
                    listToUse[data.visitorId].context = data.context;
                }
                if (data.appServerVisitorId) {
                    listToUse[data.visitorId].appServerVisitorId = data.appServerVisitorId;
                }
                if (data.sessionId) {
                    listToUse[data.visitorId].sessionId = data.sessionId;
                }
                if (data.chatId) {
                    listToUse[data.visitorId].chatId = data.chatId;
                }
                if (data.convId) {
                    listToUse[data.visitorId].convId = data.convId;
                }
                if (typeof data.newChat !== 'undefined') {
                    listToUse[data.visitorId].newChat = data.newChat;
                }
                if (typeof data.needToBindChatState !== 'undefined') {
                    listToUse[data.visitorId].needToBindChatState = data.needToBindChatState;
                }
                if (typeof data.chatState !== 'undefined') {
                    listToUse[data.visitorId].chatState = data.chatState;
                }
            }
        }

        /**
         * Removes a visitor from the active polling visitor list - and adds it to the inactive list.
         * @param visitorId {*} The visitor ID.
         */
        function removeFromActiveList(visitorId) {
            if (visitorId && pollingVisitors[visitorId]) {
                addToList(pollingVisitors[visitorId], inactiveVisitors);
                delete pollingVisitors[visitorId];
            }
        }

        /**
         * Removes a visitor from the inactive list.
         * @param visitorId {*} The visitor ID.
         */
        function removeFromInactiveList(visitorId) {
            if (visitorId && inactiveVisitors[visitorId]) {
                delete inactiveVisitors[visitorId];
            }
        }

        function stopPollingVisitorInfo(data) {
            var visitorId;
            if (data) {
                visitorId = data.visitorId;
            }
            if (visitorId) {
                var modelPath = 'participants.info.' + visitorId + '.state';
                if(visitorCallbacks[visitorId]) {
                    if(visitorCallbacks[visitorId].visitorInfoStateChanged){
                        model.unbind(modelPath, visitorCallbacks[visitorId].visitorInfoStateChanged);
                    }
                    visitorCallbacks[visitorId].visitorInfoStateChanged = null;
                }
                removeFromActiveList(visitorId);
                if (!hasVisitorsToPoll()) {
                    stopPolling();
                }
            botMetadataController.dismiss(visitorId);}
        }

        function startPollingVisitorInfo(data) {
            var visitorId;
            if (data) {
                visitorId = data.visitorId;
                var isNewChat = data.newChat;
                if (visitorId) {
                    if(pollingVisitors[visitorId] && !isNewChat){
                        return;
                    }
                    if (!visitorCallbacks[visitorId]) {
                        visitorCallbacks[visitorId] = {};
                    }
                }
            }
            botMetadataController.listenForMetadata(visitorId, data.chatId || data.convId);if (!pollingVisitors[visitorId]) {
                addToList(data, pollingVisitors);
            }
            if (pollingEnabled) {
                if (isPollingActive()) {
                    // If we're already polling - we just get the info for the requested visitor
                    getVisitorInfoOrBindToChatState(getFromActiveList(data));
                }
                startPolling(data.context);
            }
        }

        /**
         * Either adds the visitor to the polling queue, or binds to the chat state (and adds the visitor to the queue in
         * the callback).
         * @param data
         */
        function getVisitorInfoOrBindToChatState(data) {
            if (data.needToBindChatState && data.chatId) {
                bindToChatState(data);
            } else {
                addToPollingQueue(data);
            }
        }

        /**
         * Adds a visitor to the polling queue. We don't want to poll all the visitors at once to avoid CPU/memory abuse.
         * @param data
         */
        function addToPollingQueue(data) {
            setFetchingState(data.visitorId, data.newChat);
            if (!pollingQueue.contains(data)) {
                pollingQueue.enqueue(data);
            }
            if (!model.get(lpTag.lpVisitorInfoController.prototype.CURRENT_POLLING_MODEL_LOCATION)) {
                currentPollingChanged();
            }
        }

        /**
         * When we stop polling the current visitor (or we're not polling any visitor from the start) calls getVisitorInfo
         * (and sends the requests), for the next visitor in the queue.
         * @param data
         */
        function currentPollingChanged(data) {
            if ((!data || !data.newValue) && pollingQueue.size() > 0) {
                getVisitorInfo(pollingQueue.dequeue());
            }
        }

        /**
         * Checks that we have all the relevant data, and sends the requests to get the visitor info, via the controllers
         * (for the app server and monitoring data).
         * @param data - contains the data we need for the request - visitor ID, chat ID, session ID, app server visitor ID
         */
        function getVisitorInfo(data) {
            logger.info("", "getVisitorInfo", data);
            var visitorId, sessionId, appServerVisitorId, context, isNewChat;
            if (data) {
                visitorId = data.visitorId;
                sessionId = data.sessionId;
                appServerVisitorId = data.appServerVisitorId;
                isNewChat = data.newChat || false;
            }
            if (visitorId) {
                context = {
                    visitorId: visitorId,
                    chatId: data.chatId,
                    isNewChat: isNewChat,
                    convId: data.convId,
                    dataObject: {data: {visitorId: visitorId}}
                };
                // We add the data to the model as the currently polled visitor.
                // In the next refactor we should eliminate the data object and use this location in the model instead.
                model.set(lpTag.lpVisitorInfoController.prototype.CURRENT_POLLING_MODEL_LOCATION, lpTag.lpVisitorInfoController.prototype.createEmptySharedDataObject(visitorId));
                var participantPath = lpTag.WebAgent.logicController.getParticipantPath(visitorId);
                var modelPath = participantPath + ".participantInfo";
                var modelData = model.get(modelPath);
                if (!modelData) {
                    modelPath = "participants.visitorList.data." + visitorId + ".participantInfo";
                    modelData = model.get(modelPath);
                }
                if (modelData && modelData.sessionId && (! sessionId || sessionId !== modelData.sessionId)) {
                    sessionId = modelData.sessionId;
                    enrichList({visitorId: visitorId, sessionId: sessionId}, pollingVisitors);
                }
                if (lpTag.WebAgent.logicController.isVisitorAsyncMessaging(visitorId) || data.convId) {
                    context.convId = context.convId || context.chatId;
                    getUserProfileData(context);
                } else {
                    if (sessionId) {
                        context.sessionId = sessionId;
                        getMonitoringData(context);
                    }
                    if (appServerVisitorId) {
                        context.appServerVisitorId = appServerVisitorId;
                        getAppServerData(context);
                    }
                }
                if (data.needToBindChatState && data.chatId) {
                    bindToChatState(data);
                }
                enrichList({visitorId: visitorId, newChat: false, needToBindChatState: false}, pollingVisitors);
            }
        }

        /**
         * Perform all steps necessary to get the monitoring (shark) data:
         * Set the fetching state, add the service to the requested services, and send the request via the
         * visit monitoring controller.
         * @param context - the context containing the data for the request
         */
        function getMonitoringData(context) {
            if (context) {
                lpTag.lpVisitorInfoController.prototype.addServiceToRequestedServices(lpTag.lpVisitorInfoController.prototype.serviceNames.visitMonitoring, context.dataObject, model);
                visitMonitoringController.getMonitoringData(context);
            }
        }

        /**
         * Perform all steps necessary to get the app server data:
         * Set the fetching state, add the service to the requested services, and send the request via the
         * agent session visit controller.
         * @param context - the context containing the data for the request
         */
        function getAppServerData(context) {
            if (context) {
                lpTag.lpVisitorInfoController.prototype.addServiceToRequestedServices(lpTag.lpVisitorInfoController.prototype.serviceNames.agentSessionVisit, context.dataObject, model);
                agentSessionVisitController.getAppServerData(context);
            }
        }
        function getUserProfileData(context) {
            if (context) {
                lpTag.lpVisitorInfoController.prototype.addServiceToRequestedServices(lpTag.lpVisitorInfoController.prototype.serviceNames.consumerInfo, context.dataObject, model);
                consumerInfoController.getConsumerInfoData(context);
            }
        }
        /**
         * We set the visit info status to "fetching" for the given visitor if one of the following is true:
         * 1. There is no existing info state for the visitor.
         * 2. The current info state for the visitor is "error".
         * 3. We want to force this state to be "fetching" (for a new chat) using the parameter.
         * @param visitorId - The visitor ID for the info.
         * @param forceFetching - If true - we set the state to "fetching" regardless of the current state.
         */
        function setFetchingState(visitorId, forceFetching) {
            if (visitorId) {
                var modelPath = 'participants.info.' + visitorId + '.state';
                var currentState = model.get(modelPath);
                if (!currentState || forceFetching || (currentState && currentState === dataStates.error)) {
                    model.modify(modelPath, dataStates.fetching);
                }
            }
        }

        function removeVisitorInfoFromModel(data) {
            var visitorId;
            if (data && data.visitorId) {
                visitorId = data.visitorId;
            }
            if (visitorId) {
                var participantPath = lpTag.WebAgent.logicController.getParticipantPath(visitorId);
                var modelData = model.get(participantPath);
                if (!modelData) {
                    modelData = model.get('participants.info');
                    if (modelData && modelData[visitorId]) {
                        delete modelData[visitorId];
                    }
                }
            }
        }

        function handleVisitorDisposed(data) {
            if (data && data.removedValue && data.removedValue.participantInfo) {
                var visitorId = data.removedValue.participantInfo.id || data.removedValue.participantInfo.visitorId;
                var participantPath = lpTag.WebAgent.logicController.getParticipantPath(visitorId);
                model.unbind(participantPath, visitorCallbacks[visitorId].visitorDisposed);
                model.unbind(participantPath + ".chats", visitorCallbacks[visitorId].newChat);
                visitorCallbacks[visitorId].visitorDisposed = null;
                visitorCallbacks[visitorId].newChat = null;
                stopPollingVisitorInfo({visitorId: visitorId});
                removeFromInactiveList(visitorId);
                delete visitorCallbacks[visitorId];
                removeVisitorInfoFromModel({visitorId: visitorId});
                unbindFromUIEvents(visitorId);
                botMetadataController.dismiss(visitorId);if (data.context && data.context.isAsyncMessaging) {
                    consumerInfoController.handleVisitorDisposed(visitorId);
                    if (data.context.chatId) {
                        var chatId = data.context.chatId;
                        removeChatFromList(chatId);
                    }
                }
            }
        }

        function changeFocus(data) {
            if (data && data.newValue) {
                var visitorId = data.newValue.appName;
                if (visitorId) {
                    var visitorInfo = pollingVisitors[visitorId];
                    if (!visitorInfo) {
                        visitorInfo = inactiveVisitors[visitorId];
                    }
                    if (visitorInfo) {
                        if (data.newValue.UIEvent === window.App.viewEventsHandler.eventType.VISITOR_BLURRED) {
                            visitorPollingManager.setInactiveItem(visitorInfo);
                        } else if (data.newValue.UIEvent === window.App.viewEventsHandler.eventType.VISITOR_FOCUSED) {
                            visitorPollingManager.setActiveItem(visitorInfo);
                        }
                    }
                }
            }
        }

        function disposeVisitor(data) {
            var visitorId = data && data.newValue && data.newValue.appName;
            if (visitorId) {
                handleVisitorDisposed({removedValue: {participantInfo: {id: visitorId}}});
            }
        }

        function bindToUIEvents(visitorId) {
            window.App.viewEventsHandler.bindEvent({
                appName: visitorId,
                UIEvent: window.App.viewEventsHandler.eventType.VISITOR_FOCUSED,
                callback: changeFocus
            });
            window.App.viewEventsHandler.bindEvent({
                appName: visitorId,
                UIEvent: window.App.viewEventsHandler.eventType.VISITOR_BLURRED,
                callback: changeFocus
            });
            window.App.viewEventsHandler.bindEvent({
                appName: visitorId,
                UIEvent: window.App.viewEventsHandler.eventType.VISITOR_DISPOSED,
                callback: disposeVisitor
            });
        }

        function unbindFromUIEvents(visitorId) {
            window.App.viewEventsHandler.unbindEvent({
                appName: visitorId,
                UIEvent: window.App.viewEventsHandler.eventType.VISITOR_FOCUSED,
                callback: changeFocus
            });
            window.App.viewEventsHandler.unbindEvent({
                appName: visitorId,
                UIEvent: window.App.viewEventsHandler.eventType.VISITOR_BLURRED,
                callback: changeFocus
            });
            window.App.viewEventsHandler.unbindEvent({
                appName: visitorId,
                UIEvent: window.App.viewEventsHandler.eventType.VISITOR_DISPOSED,
                callback: disposeVisitor
            });
        }
    };
    lpTag.lpVisitorInfoController.prototype = new lpBaseInfoController();

    return lpTag.lpVisitorInfoController;

});
